import { APPROVAL_PHASE } from "@erp/shared/components/ui/Approval/approval-phase.types";
export const defaultCheckBoxItem = {
    text: "(버전 없음)",
    approvalPhase: APPROVAL_PHASE.잘못된승인단계,
    value: 0,
};
